import React, { Component } from 'react';
import { getToken } from '../../functions/app_functions.js';
import withRouter from '../../with_router.js';


class ActivateEmail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
        };

        this.handleVerifyEmail = this.handleVerifyEmail.bind(this);
    }


    componentDidMount() {
        const email = this.props.searchParams.get("email");
        const user_id = this.props.searchParams.get("uid");
        const login_id = this.props.searchParams.get("lid");

        this.setState({
            email: email,
            user_id: user_id,
            login_id: login_id
        })
    }


    async handleVerifyEmail(data) {
        this.props.setLoading();
        try {
            // Send request
            var response = await fetch(this.props.baseUrl + "/verifyuseremail", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    email: this.state.email,
                    user_id: this.state.user_id,
                    login_id: this.state.login_id
                }),
            });
            // Process response
            response = await response.json();

            // Process data
            var data = response.value;
            if (data) {
                // Track event
                this.props.logEvent("User activity", "Email verified");
                // Forward to home page
                this.props.goToPage("/");
            } else {
                // Track error
                var name = "Server error";
                var message = "Could not verify email. Please try again later.";
                this.props.setError(name, message);
                // Track event
                this.props.logEvent("Client error", "Activateemail_handleVerifyEmail");
            }
            this.props.unsetLoading();
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "Server error";
            var message = "Could not verify email. Please try again later.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Activateemail_handleVerifyEmail");
            this.props.unsetLoading();
        }
    }


    render() {

        return (
            <div className="content-container">
                <div className="form-container form-container--with-background">
                    <div className="form__background form__background--trip">
                    </div>
                    <div className="form__overlay"></div>
                    <div className="form__popup-container">
                        <div className="form__popup">

                            {/* <div className="trip__popup__title text-subtitle">
                                Verify your email
                            </div> */}

                            <div className="trip__popup__section">
                                <div className="trip__popup__element">
                                    <div className="trip__popup__element__label text-subtitle">
                                        Email
                                    </div>
                                    <div className="trip__popup__element__content">
                                        {this.state.email}
                                    </div>
                                </div>
                            </div>

                            <div className="trip__popup__section">
                                <div className="trip__popup__element trip__popup__buttonbox">
                                    {(this.state.email && this.state.user_id && this.state.login_id) &&
                                        <button onClick={this.handleVerifyEmail} className={"button button-primary trip__popup__buttonbox__button--single-button"}>
                                            Verify email
                                        </button>
                                    }
                                    {!(this.state.email && this.state.user_id && this.state.login_id) &&
                                        <button className={"button button-inactive trip__popup__buttonbox__button--single-button"}>
                                            Loading...
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default withRouter(ActivateEmail);